import styled from 'styled-components';
import Grid from '@lendi-ui/grid';
import { ml, pl, mt, mb } from '@lendi-ui/spacing';
import { Body } from '@lendi-ui/typography';

export const DependantsDetailsWrapper = styled.div`
  > *:not(:first-child) {
    ${mt('sm')}
  }

  ${mt('xxs')}
  ${mb('md')}
`;

export const IndexDisplay = styled.div`
  font-weight: 800;
  font-family: ${(props) => `${props.theme.typography.heading.fontFamily}`};
`;

export const WithWhoColumnHeader = styled(Body)`
  display: inline-block;
  ${ml('xxs')}
`;

export const GridWithPaddedUnits = styled(Grid)`
  /* Gives a padding left to all its children except the first */
  & > * {
    ${pl('xxs')} :first-child {
      ${pl('nil')}
    }
  }
`;
